import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { setDestRhythmOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'

export function* getDestRhythmOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getDestRhythmOptions])
    const { entity } = response
    yield put(setDestRhythmOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getDestRhythmOptions() error: ${e}`))
  }
}

export function* getDestRhythmOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getDestRhythmOptions)
}
